import { gql } from '@apollo/client';

export const BusinessDomainData = `
  id
  name
  status
  tenant
`;

export const GET_BUSINESS_DOMAIN_LIST = gql`
  query BusinessDomain_getList($query: QueryBusinessDomainInput) {
    BusinessDomain_getList(query: $query) {
      ${BusinessDomainData}
    }
  }
`;

export const GET_BUSINESS_DOMAIN_BY_ID = gql`
  query BusinessDomain_getById($id: String!) {
    BusinessDomain_getById(id: $id) {
      ${BusinessDomainData}
    }
  }
`;
